import React from 'react';
import screens from 'shared/screens';
import { ASSET_KEY, assetSource } from 'shared/utils/assetSource';
import { pwaStyleAdapter } from '../../../utils/mobileSupported';
import ImageBoundsWrapper from '../../ImageBoundsWrapper';
import styled from 'styled-components';

const SettingsMenu = ({ showModal, themeContext }) => {
  return (
    <MenuButton className="proto" onClick={() => showModal(screens.Settings)}>
      <ImageBoundsWrapper
        source={assetSource(ASSET_KEY.MENU_HAMBURGER)}
        ibw={require(asset`images/top-bar-assets/menu-hamburger.ibw`)}
        style={pwaStyleAdapter(themeContext.NavigationBar.SettingIcon)}
      />
    </MenuButton>
  );
};

const MenuButton = styled.button`
  all: unset;
  
  display: inline-block;
  max-width: 25%;
  cursor: pointer;
  
  &:focus,
  &:active,
  &:hover {
    outline: none !important;
    border: none !important;
    background: none !important;
    box-shadow: none !important;
  }
  
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
`;

export default SettingsMenu;

